// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ``, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
var _1 = `1620px`;
export { _1 as "container-md" };
var _2 = `1366px`;
export { _2 as "container-sm" };
var _3 = `4px`;
export { _3 as "border-radius-big" };
var _4 = `226px`;
export { _4 as "left-panel-width" };
var _5 = `6px`;
export { _5 as "default-scroll-width" };
var _6 = `81px`;
export { _6 as "list-item-height" };
var _7 = `24px`;
export { _7 as "icon-button-size" };
var _8 = `18px`;
export { _8 as "icon-button-small-size" };
var _9 = `20px`;
export { _9 as "button-size-extra-small" };
var _a = `32px`;
export { _a as "button-size-small" };
var _b = `48px`;
export { _b as "button-size-normal" };
var _c = `64px`;
export { _c as "button-size-big" };
var _d = `52px`;
export { _d as "main-header-height" };
var _e = `52px`;
export { _e as "footer-height" };
var _f = `64px`;
export { _f as "page-header-height" };
var _10 = `64px`;
export { _10 as "rs-left-panel-width" };
var _11 = `48px`;
export { _11 as "rs-results-tabs-height" };
var _12 = `64px`;
export { _12 as "rs-results-header-height" };
var _13 = `48px`;
export { _13 as "rs-results-element-header-height" };
var _14 = `48px`;
export { _14 as "rs-cell-model-sub-header-height" };
var _15 = `560px`;
export { _15 as "workspace-list-width" };
var _16 = `96px`;
export { _16 as "workspace-list-item-height" };
var _17 = `80px`;
export { _17 as "rs-list-item-height" };
var _18 = `248px`;
export { _18 as "dialog-button-width" };
var _19 = `640px`;
export { _19 as "select-item-max-width" };
var _1a = `6px`;
export { _1a as "node-handle-size" };
var _1b = `40px`;
export { _1b as "input-height" };
var _1c = `60px`;
export { _1c as "table-cell-height" };
var _1d = `500`;
export { _1d as "font-weight-light" };
var _1e = `500`;
export { _1e as "font-weight-regular" };
var _1f = `600`;
export { _1f as "font-weight-medium" };
export default ___CSS_LOADER_EXPORT___;
